import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { TELEMETRY_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_VEHICLES_LIST = '_LOAD_VEHICLES_LIST';
export const LOAD_TELEMETRY_LIST_ALL = '_LOAD_TELEMETRY_LIST_ALL';
export const CREATE_VEHICLES = '_CREATE_VEHICLES';
export const LOAD_VEHICLES_BY_ID = '_LOAD_VEHICLES_BY_ID';
export const EDIT_VEHICLES_BY_ID = '_EDIT_VEHICLES_BY_ID';
export const DELETE_VEHICLES = '_DELETE_VEHICLES';

export const loadTelemetryList = createDeferredAction(TELEMETRY_MODULE + LOAD_VEHICLES_LIST);
export const loadTelemetryListBegin = createDeferredAction(TELEMETRY_MODULE + LOAD_VEHICLES_LIST + BEGIN);
export const loadTelemetryListSuccessful = createAction(TELEMETRY_MODULE + LOAD_VEHICLES_LIST + SUCCESSFUL);
export const loadTelemetryListFailed = createAction(TELEMETRY_MODULE + LOAD_VEHICLES_LIST + FAILED);

export const loadTelemetryListAll = createDeferredAction(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL);
export const loadTelemetryListAllBegin = createDeferredAction(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL + BEGIN);
export const loadTelemetryListAllSuccessful = createAction(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL + SUCCESSFUL);
export const loadTelemetryListAllFailed = createAction(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL + FAILED);

export const createTelemetry = createDeferredAction(TELEMETRY_MODULE + CREATE_VEHICLES);
export const createTelemetrySuccessful = createAction(TELEMETRY_MODULE + CREATE_VEHICLES + SUCCESSFUL);
export const createTelemetryFailed = createAction(TELEMETRY_MODULE + CREATE_VEHICLES + FAILED);

export const loadTelemetryById = createDeferredAction(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID);
export const loadTelemetryByIdSuccessful = createAction(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID + SUCCESSFUL);
export const loadTelemetryByIdFailed = createAction(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID + FAILED);
export const loadTelemetryByIdClear = createDeferredAction(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID + CLEAR);

export const editTelemetryById = createDeferredAction(TELEMETRY_MODULE + EDIT_VEHICLES_BY_ID);
export const editTelemetryByIdSuccessful = createAction(TELEMETRY_MODULE + EDIT_VEHICLES_BY_ID + SUCCESSFUL);
export const editTelemetryByIdFailed = createAction(TELEMETRY_MODULE + EDIT_VEHICLES_BY_ID + FAILED);

export const deleteTelemetry = createDeferredAction(TELEMETRY_MODULE + DELETE_VEHICLES);
export const deleteTelemetrySuccessful = createAction(TELEMETRY_MODULE + DELETE_VEHICLES + SUCCESSFUL);
export const deleteTelemetryFailed = createAction(TELEMETRY_MODULE + DELETE_VEHICLES + FAILED);
